import { render, staticRenderFns } from "./guardianship.vue?vue&type=template&id=d0dfd948&scoped=true&"
import script from "./guardianship.vue?vue&type=script&lang=js&"
export * from "./guardianship.vue?vue&type=script&lang=js&"
import style0 from "./guardianship.vue?vue&type=style&index=0&id=d0dfd948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dfd948",
  null
  
)

export default component.exports